export default [
  {
    path: "/product",
    name: "Product",
    component: () => import("@/views/Product/Product"),
    meta: { title: "ETH AI " },
  },
  {
    path: "/product1",
    name: "Product1",
    component: () => import("@/views/Product/Product1"),
    meta: { title: "ETH AI " },
  },
  {
    path: "/productInfo",
    name: "ProductInfo",
    component: () => import("@/views/Product/ProductInfo"),
    meta: { title: "理财订单" },
  },
  {
    path: "/productOrder",
    name: "productOrder",
    component: () => import("@/views/Product/productOrder"),
    meta: { title: "理财订单" },
  },
  {
    path: "/productBuy",
    name: "ProductBuy",
    component: () => import("@/views/Product/ProductBuy"),
    meta: { title: "理财购买" },
  },
  {
    path: "/productBuy1",
    name: "ProductBuy1",
    component: () => import("@/views/Product/ProductBuy1"),
    meta: { title: "理财购买" },
  },
  {
    path: "/ProductFlow",
    name: "ProductFlow",
    component: () => import("@/views/Product/ProductFlow"),
    meta: { title: "理财流水" },
  },
  {
    path: "/protocol",
    name: "protocol",
    component: () => import("@/views/Product/protocol"),
    meta: { title: "协议" },
  },
];



// WEBPACK FOOTER //
// ./src/router/config/Product.js